import { render } from "./OrderModifier.vue?vue&type=template&id=34294dd6&scoped=true"
import script from "./OrderModifier.vue?vue&type=script&lang=js"
export * from "./OrderModifier.vue?vue&type=script&lang=js"

import "./OrderModifier.vue?vue&type=style&index=0&id=34294dd6&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/kds/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34294dd6"]])

export default __exports__